module.exports = __webpack_public_path__ + "img/0-md.ff612dad.jpg";